module.exports = __webpack_public_path__ + "img/not_saved.df3f144d.svg";